export const PREVIEW_ACCESS_TYPE_MESSAGE = `This component may have limited features or support. Please contact support if you have any questions`;
